import { InviteComponent } from "../components/NetworkMint/Steps/Mint/Invitations";
import { useRouter } from "next/router";
import SEO from "../components/Seo/Seo";
import MintLayout from "../components/Layouts/Mint";
import { ReactElement, useEffect, useState } from "react";
import { useUserContext } from "../contexts/User";
import { makeInvites } from "../utils/api/generateInvites";
import { useAccount, useReadContract } from "wagmi";
import { coinageRead } from "../useCoinageContract";
import PageLoader from "../components/LoadingIndicators/PageLoader";

const InvitationsPage = () => {
  const { push } = useRouter();
  const { user } = useUserContext();
  const [loading, setIsLoading] = useState(true);
  const { address } = useAccount();

  const { data: networkCount } = useReadContract({
    ...coinageRead,
    functionName: "balanceOf",
    query: {
      enabled: Boolean(address)
    },
    args: [address, 1]
  });

  useEffect(() => {
    // check if user owns a network token
    // if they own it, we call the `make-invites`
    // make invites will handle logic if they have already minted or not

    const checkIfOwnsTokenAndMakeInvites = async () => {
      if (!user?.id || !networkCount) return;
      const ownsToken = Number(networkCount?.toString()) > 0;
      if (ownsToken && user?.id) {
        await makeInvites({ id: user?.id });
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    };

    checkIfOwnsTokenAndMakeInvites();
  }, [user?.id, networkCount]);

  const handleClick = () => push("/");

  return (
    <>
      <SEO title="Get Your Referral Codes | Coinage Media" />
      <section className="max-w-4xl flex items-center mt-20 mx-auto px-12">
        {loading ? <PageLoader /> : <InviteComponent onSuccess={handleClick} />}
      </section>
    </>
  );
};

InvitationsPage.getLayout = function getLayout(page: ReactElement) {
  return <MintLayout hideMenu>{page}</MintLayout>;
};

export default InvitationsPage;
